import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const FakeSequencer = (props) => { 
    return (
        <div className="fake-sequencer">
          <div className="sequencer-row">
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step on={true}/>
            <Step on={true}/>
            <Step on={true}/>
            <Step on={true}/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
          </div>
          <div className="sequencer-row">
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step on={false}/>
            <Step on={false}/>
            <Step on={true}/>
            <Step on={false}/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
          </div>
          <div className="sequencer-row">
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step on={false}/>
            <Step on={true}/>
            <Step on={false}/>
            <Step on={false}/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
          </div>
          <div className="sequencer-row">
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step on={true}/>
            <Step on={true}/>
            <Step on={true}/>
            <Step on={true}/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
            <Step/>
          </div>
        </div>
    );
}

const Step = ({on}) => {
    return (<div className={on ? "step on" : "step"}/>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FakeSequencer);
